import { parseISO } from "date-fns";

import { DisplayError, DisplaySuccess } from "../../../actions/notifications.actions";

import request from "../base-request";

interface ITeamsAPIResponse<T> {
	data: T;
}

interface ITeamsMetadataResponse extends ITeamsAPIResponse<object> {}
interface ITeamsConfigResponse extends ITeamsAPIResponse<object> {}
interface ITeamsListResponse extends ITeamsAPIResponse<object> {}
interface ITeamsHasAdminConsentResponse extends ITeamsAPIResponse<object> {
	hasAdminConsent: boolean;
	hasAdminConsentV2: boolean;
}

interface ITeamsAutoSyncSettings {
	proactive_install: "auto" | "manual";
}

interface ITeamsConnectedUserCountResponse {
	count: number;
}

interface ITeamsLastSyncDateResponse {
	lastSyncDate: string;
}

interface ITeamsAppInstallParams {
	filters: {
		tenantID: string;
		teamID: string;
	};
}

export const fetchTeamsConfig = async () => {
	const [data] = await request<ITeamsMetadataResponse>(`/api/microsoft_teams/config/`);

	const response = { ...data };

	return response;
};
export const fetchHasTeamsAdminConsent = async () => {
	const [data] = await request<ITeamsHasAdminConsentResponse>(`/api/microsoft_teams/has_admin_consent/`);

	const response = { ...data };

	return response;
};
export const fetchTeamsMetadata = async () => {
	const [data] = await request<ITeamsConfigResponse>(`/api/microsoft_teams/metadata/`);

	const response = { ...data };

	return response;
};
export const fetchTeamsList = async () => {
	const [data] = await request<ITeamsListResponse>(`/api/microsoft_teams/fetch-teams-on-tenant/`);

	const response = { ...data };

	return response;
};

export const updateTeamsAutoSyncSettings = async (settings: { proactive_install: "auto" | "manual" }) => {
	const [data] = await request<ITeamsAutoSyncSettings>("/api/microsoft_teams/auto_sync/", {
		method: "PATCH",
		body: JSON.stringify(settings),
	});

	return { ...data };
};

export const postTeamsManualSync = async (dispatch) => {
	try {
		const [data] = await request<ITeamsAutoSyncSettings>("/api/microsoft_teams/manual_sync/", {
			method: "POST",
			body: JSON.stringify({}),
		});

		dispatch(DisplaySuccess("Syncing Users"));

		return { ...data };
	} catch (e) {
		dispatch(DisplayError("Failed Sync"));
	}
};

export const fetchTeamsAutoSyncSettings = async () => {
	const [data] = await request<ITeamsAutoSyncSettings>(`/api/microsoft_teams/auto_sync/`);

	const response = { ...data };

	return response;
};

export const fetchTeamsConnectedUserCount = async () => {
	const [data] = await request<ITeamsConnectedUserCountResponse>(`/api/microsoft_teams/connected_user_count/`);

	const response = { ...data };

	return response;
};

export const fetchTeamsLastSyncDate = async () => {
	const [data] = await request<ITeamsLastSyncDateResponse>(`/api/microsoft_teams/last_sync_date/`);

	const response = data?.lastSyncDate ? new Date(parseISO(data.lastSyncDate)) : null;

	return response;
};

export const installTeamsApp = async (params: ITeamsAppInstallParams) => {
	const [data] = await request(`/api/microsoft_teams/install/`, {
		method: "POST",
		body: JSON.stringify(params),
	});
	return data;
};

export const uninstallTeamsApp = async (params: ITeamsAppInstallParams) => {
	const [data] = await request(`/api/microsoft_teams/uninstall/`, {
		method: "POST",
		body: JSON.stringify(params),
	});
	return data;
};

export const resyncTeamsApp = async (params: ITeamsAppInstallParams) => {
	await uninstallTeamsApp(params);
	await installTeamsApp(params);
};
